import { Language } from '@configs/language';

const BASE_LABELS = {
  editMmbInfoTitle: 'Information',
  editMmbInfoActive: 'Active',
  editMmbInfoInactive: 'Inactive',
  editMmbInfoEmail: 'Email',
  editMmbInfoRole: 'Role',
  editMmbInfoStatus: 'Status',
  editMmbInfoDelete: 'Delete member',
  editMmbUpdateRole: 'Update',
  editMmbRoleTitle: 'Assigned role',
  editMmbRoleFunctions: 'Functions',
  editMmbRoleCan: 'Can',
  editMmbRoleCannot: 'Cannot',
  editMmbPayments:
    'send payments, mass payments, conversions, forwards, payment links.',
  editMmbAddFunds: 'add funds.',
  editMmbAddGlobalAccounts: 'add global accounts.',
  editMmbWithdrawals: 'withdraw funds.',
  editMmbDownloadStatements: 'download receipts and account statements.',
  editMmbAddBeneficiaries: 'add contacts.',
  editMmbDeleteAccount: 'close the EFEX account.',
  editMmbTeamMembers: 'add new team members.',
  editMmbEditTeamMembers:
    'deactivate and activate team members who are {{roles}}.',
  editMmbTeamMemberRole: 'edit the role of each member.',
  editMmbTeamMemeberDelete: 'delete a member from your team.',
  editMmbTransferToOtherMember: 'transfer their role to another member.',
  editMmbApprovePayments: 'approve payments, conversions and payment links.',
  roleOwnerDescription:
    'This role can perform any action on the organization account, such as making payments, withdrawing funds to the configured bank account, as well as managing users and account settings.',
  roleApproverDescription:
    'This role can approve payments configured by another team member. It can perform transfers without approval.',
  roleConfiguratorDescription:
    'This role can configure transfers but cannot execute them. For that, it needs the approval of the owner or any approver.',
  roleReaderDescription:
    'This role can view the organization account information, but cannot perform any action.',
  roleConfiguratorDisclaimer:
    'The owner or approvers of your team will need to approve payments configured by this member.',
  roleUpdateModalTitle: 'Are you sure you want to update member {{name}}?',
  roleUpdateModalAction: 'Yes, update',
  roleUpdateModalError: 'Error updating member',
  roleDeleteModalTitle: 'Are you sure you want to delete member {{name}}?',
  roleDeleteModalAction: 'Yes, delete',
  roleDeleteModalError: 'Error deleting member',
};

type LabelsLanguage = keyof typeof BASE_LABELS;

const EDIT_TEAM_MEMBER_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LABELS,
  ES: {
    editMmbInfoTitle: 'Información',
    editMmbInfoActive: 'Activo',
    editMmbInfoInactive: 'Inactivo',
    editMmbInfoEmail: 'Correo',
    editMmbInfoRole: 'Rol',
    editMmbInfoStatus: 'Estado',
    editMmbInfoDelete: 'Eliminar miembro',
    editMmbUpdateRole: 'Actualizar',
    editMmbRoleTitle: 'Rol asignado',
    editMmbRoleFunctions: 'Funciones',
    editMmbRoleCan: 'Puede',
    editMmbRoleCannot: 'No puede',
    editMmbPayments:
      'enviar pagos, pagos masivos, conversiones, forwards, links de cobro.',
    editMmbAddFunds: 'añadir fondos.',
    editMmbAddGlobalAccounts: 'añadir cuentas globales.',
    editMmbWithdrawals: 'retirar fondos.',
    editMmbDownloadStatements: 'descargar comprobantes y estados de cuenta.',
    editMmbAddBeneficiaries: 'añadir contactos.',
    editMmbDeleteAccount: 'cerrar la cuenta EFEX.',
    editMmbTeamMembers: 'añadir nuevos miembros al equipo.',
    editMmbEditTeamMembers:
      'desactivar y activar a los miembros del equipo que sean {{roles}}.',
    editMmbTeamMemberRole: 'editar el rol de cada miembro.',
    editMmbTeamMemeberDelete: 'eliminar a un miembro de su equipo.',
    editMmbTransferToOtherMember: 'transferir su rol a otro miembro.',
    editMmbApprovePayments: 'aprobar pagos, conversiones y links de cobro.',
    roleOwnerDescription:
      'Este rol puede realizar cualquier acción en la cuenta de la organización, como realizar pagos, retirar fondos a la cuenta bancaria configurada, así cómo la gestión de usuarios y la configuración de la cuenta.',
    roleApproverDescription:
      'Este rol puede aprobar pagos configurados por otro miembro del equipo. Puede realizar transferencias sin aprobación.',
    roleConfiguratorDescription:
      'Este rol puede configurar transferencias pero no puede ejecutarlas. Para eso necesita de la aprobación del propietario o cualquier aprobador.',
    roleReaderDescription:
      'Este rol puede ver la información de la cuenta de la organización, pero no puede realizar ninguna acción.',
    roleConfiguratorDisclaimer:
      'El propietario o los aprobadores de tu equipo deberán aprobar los pagos que configure este miembro.',
    roleUpdateModalTitle: '¿Seguro que deseas actualizar al miembro {{name}}?',
    roleUpdateModalAction: 'Si, actualizar',
    roleUpdateModalError: 'Error al actualizar el miembro',
    roleDeleteModalTitle: '¿Seguro que deseas eliminar al miembro {{name}}?',
    roleDeleteModalAction: 'Si, eliminar',
    roleDeleteModalError: 'Error al eliminar el miembro',
  },
};

export default EDIT_TEAM_MEMBER_LABELS;
